const CONSENT_KEY = 'autonia_cookie_consent';

let analyticsEnabled = false;

function buildConsentAPI(prefs) {
  window.autoniaCookieConsent = {
    has:    (cat) => !!prefs[cat],
    getAll: ()    => ({ ...prefs }),
    reopen: ()    => openBanner(),
  };
}

function saveConsent(prefs) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(prefs));
  buildConsentAPI(prefs);
  closeBanner();
  // Lets scripts that write "technisch notwendige" cookies (e.g. payment-state.js)
  // catch up once consent has actually been given — they must not write anything
  // before this fires, even though those cookies don't need the analytics toggle.
  window.dispatchEvent(new CustomEvent('autonia:cookieConsent', { detail: prefs }));
}

function openBanner() {
  const banner = document.getElementById('cookie-banner');
  if (!banner) return;

  // Reset toggle state to off on every open
  analyticsEnabled = false;
  const toggle      = document.getElementById('cookie-toggle-analytics');
  const toggleThumb = toggle?.querySelector('span');
  if (toggle) {
    toggle.setAttribute('aria-checked', 'false');
    toggle.classList.remove('bg-autonia-orange');
    toggle.classList.add('bg-slate-300');
    toggleThumb?.classList.remove('translate-x-5');
  }

  banner.classList.remove('hidden');
  document.body.style.overflow = 'hidden';
}

function closeBanner() {
  const banner = document.getElementById('cookie-banner');
  if (banner) banner.classList.add('hidden');
  document.body.style.overflow = '';
}

export default function initCookieConsent() {
  // Always expose the API from stored consent
  const stored = localStorage.getItem(CONSENT_KEY);
  if (stored) {
    try { buildConsentAPI(JSON.parse(stored)); }
    catch (_) { buildConsentAPI({ necessary: true, analytics: false }); }
  }

  // Attach event listeners once — work for both initial open and reopen
  const toggle      = document.getElementById('cookie-toggle-analytics');
  const toggleThumb = toggle?.querySelector('span');

  toggle?.addEventListener('click', () => {
    analyticsEnabled = !analyticsEnabled;
    toggle.setAttribute('aria-checked', String(analyticsEnabled));
    toggle.classList.toggle('bg-autonia-orange', analyticsEnabled);
    toggle.classList.toggle('bg-slate-300',      !analyticsEnabled);
    toggleThumb?.classList.toggle('translate-x-5', analyticsEnabled);
  });

  document.getElementById('cookie-accept-all')?.addEventListener('click', () => {
    saveConsent({ necessary: true, analytics: true });
  });

  // "Nur notwendige" always saves analytics: false — regardless of toggle state
  document.getElementById('cookie-accept-necessary')?.addEventListener('click', () => {
    saveConsent({ necessary: true, analytics: false });
  });

  // Show banner only if no consent stored yet
  if (!stored) openBanner();
}
